import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostListener,
  inject,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ThemeService } from '../../services/theme/theme.service';

@Component({
  selector: 'app-theme-picker',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  templateUrl: './theme-picker.component.html',
  styleUrl: './theme-picker.component.scss',
})
export class ThemePickerComponent {
  readonly themeService = inject(ThemeService);
  private readonly cdr = inject(ChangeDetectorRef);

  open = false;

  toggle(event: Event): void {
    event.stopPropagation();
    this.open = !this.open;
    this.cdr.markForCheck();
  }

  selectPalette(id: string, event: Event): void {
    event.stopPropagation();
    this.themeService.selectPalette(id);
    this.open = false;
    this.cdr.markForCheck();
  }

  toggleDark(event: Event): void {
    event.stopPropagation();
    this.themeService.toggleDarkMode();
    this.cdr.markForCheck();
  }

  onPanelClick(event: Event): void {
    event.stopPropagation();
  }

  @HostListener('document:click')
  close(): void {
    if (!this.open) {
      return;
    }
    this.open = false;
    this.cdr.markForCheck();
  }
}
